import React from 'react';
import { useSessionInfoQuery } from '@/api/useSessionInfoQuery';
import { useSessionStore } from '@/state/sessionStore';

export type UserLoginProps = {
  href?: string;
  className?: string;
  loginLabel?: string;
};

/**
 * Renders a login link when the user is a guest.
 * If the user is logged in, renders nothing.
 */
const UserLogin: React.FC<UserLoginProps> = ({
  href = '/user',
  className = 'theme-button block w-full px-3 py-3 text-xl font-bold tracking-wider text-center uppercase',
  loginLabel = 'Login',
}) => {
  // Trigger session info fetch to keep the store updated
  useSessionInfoQuery();
  const isGuest = useSessionStore((s) => s.isGuest);
  const effectiveIsGuest = isGuest ?? true;

  if (!effectiveIsGuest) return null;

  return (
    <a href={href} className={className}>
      {loginLabel}
    </a>
  );
};

export default UserLogin;
